<template>
  <fragment>
    <div class="map-container" ref="mapcontainer">
      <DrivingControls v-if="$route.name !== 'MapModal'" />
      <YearControls v-if="$route.name !== 'MapModal'" />
      <div class="search">
        <SearchBox />
        <div
          class="minimobile"
          v-if="$store.state.isMobile && $store.state.isLandscape"
        >
          <MiniMobileHeaderBar />
        </div>
      </div>
      <div class="BookViewToggle-container">
        <BookViewToggle />
      </div>
      <div class="help" v-if="$store.state.ui.mode !== 'book-view'">
        <HelpButton @click="$store.dispatch('showDriveTour')" />
      </div>
      <ScrollControls v-if="$route.name !== 'MapModal'" />
      <TouchControls
        v-if="$route.name !== 'MapModal'"
        :container="$refs.mapcontainer"
        :truck="$refs.ride"
      />
      <div
        :class="{
          'map-view': true,
          flipped,
          'book-view': $store.state.ui.mode === 'book-view',
          transitioning: mapViewTransitioning
        }"
        ref="container"
      >
        <div
          :class="{
            top: true,
            canvas: true,
            shrunk: years.length > 1 && flipped,
            expanded: years.length > 1 && !flipped,
            flipped,
            'no-map': $store.state.ui.mode === 'no-map',
            'no-years': $store.state.ui.mode === 'no-years',
            'year-highlight': $store.state.ui.mode === 'year-highlight',
            'highlight-flip': $store.state.ui.mode === 'highlight-flip',
            'highlight-location': $store.state.ui.mode === 'highlight-location',
            narrative: $store.state.ui.mode === 'narrative',
            onesided:
              $store.state.isMobile &&
              $store.state.isLandscape &&
              $route.name === 'narrative'
          }"
          ref="canvastop"
        >
          <div class="flex">
            <transition
              v-for="year in $store.state.years"
              :key="year"
              name="grow"
            >
              <div
                class="subcanvas"
                :key="year + 'c'"
                v-if="years.indexOf(year) >= 0"
                :style="{ height: 100 / years.length + '%' }"
              >
                <ImageFlipper
                  :upsidedown="false"
                  :data="
                    $store.getters.mappedImages[year]
                      ? $store.getters.mappedImages[year].north
                      : []
                  "
                  :parent="$refs.canvastop"
                  :n="years.length"
                  :index="years.indexOf(year)"
                  side="north"
                />
              </div>
            </transition>
          </div>
        </div>
        <div
          :class="{
            map: true,
            'no-map': $store.state.ui.mode === 'no-map',
            'no-years': $store.state.ui.mode === 'no-years'
          }"
          @transitioncancel="handleTransitionEnd()"
          @transitionend="handleTransitionEnd()"
          @transitionstart="handleTransitionStart()"
          v-if="$store.getters.currentLatLonZoom.point"
        >
          <MglMap
            :accessToken="mapboxGlAccessToken"
            :mapStyle="mapboxGlStyle"
            :center="$store.getters.currentLatLonZoom.point"
            :zoom="zoom"
            :bearing="$store.getters.currentLatLonZoom.bearing"
            :scrollZoom="false"
            :dragRotate="false"
            @load="mapLoaded"
            v-if="$store.state.ui.mode !== 'book-view'"
          >
          </MglMap>
          <div
            :class="{
              'inset-button': true,
              flipped
            }"
            @click="$store.dispatch('setInsetOpen')"
          >
            <InsetButton />
          </div>
          <div class="ride-wrapper" ref="ride">
            <Ride :flipped="flipped" />
          </div>
          <div
            class="intersections-wrapper"
            v-if="$store.state.ui.mode === 'book-view'"
          >
            <Intersections />
          </div>
          <div
            class="navigate-left"
            v-if="$store.state.ui.mode === 'book-view'"
            @click="navigate(+1)"
          >
            <NextButton />
          </div>
          <div
            class="navigate-right"
            v-if="$store.state.ui.mode === 'book-view'"
            @click="navigate(-1)"
          >
            <NextButton />
          </div>
        </div>
        <div
          :class="{
            bottom: true,
            canvas: true,
            shrunk: years.length > 1 && !flipped,
            expanded: years.length > 1 && flipped,
            'no-map': $store.state.ui.mode === 'no-map',
            'no-years': $store.state.ui.mode === 'no-years',
            'year-highlight': $store.state.ui.mode === 'year-highlight',
            'highlight-flip': $store.state.ui.mode === 'highlight-flip',
            'highlight-location': $store.state.ui.mode === 'highlight-location',
            narrative: $store.state.ui.mode === 'narrative',
            flipped,
            onesided:
              $store.state.isMobile &&
              $store.state.isLandscape &&
              $route.name === 'narrative'
          }"
          ref="canvasbottom"
        >
          <div class="flex">
            <transition
              v-for="year in $store.state.years.slice().reverse()"
              :key="year + 'bottom'"
              name="grow"
            >
              <div
                class="subcanvas"
                :key="year + 'bottomc'"
                v-if="years.indexOf(year) >= 0"
                :style="{ height: 100 / years.length + '%' }"
              >
                <ImageFlipper
                  :upsidedown="true"
                  :data="
                    $store.getters.mappedImages[year]
                      ? $store.getters.mappedImages[year].south
                      : []
                  "
                  :parent="$refs.canvastop"
                  :n="years.length"
                  :index="years.indexOf(year)"
                  side="south"
                /></div
            ></transition>
          </div>
        </div>
      </div>
      <div
        :class="{
          'map-view': true,
          'interface-shadow': true,
          'book-view': $store.state.ui.mode === 'book-view',
          transitioning: mapViewTransitioning
        }"
      >
        <div
          :class="{
            top: true,
            canvas: true,
            shrunk: false,
            expanded: years.length > 1,
            'no-map': $store.state.ui.mode === 'no-map',
            'no-years': $store.state.ui.mode === 'no-years',
            'year-highlight': $store.state.ui.mode === 'year-highlight',
            'highlight-flip': $store.state.ui.mode === 'highlight-flip',
            'highlight-location': $store.state.ui.mode === 'highlight-location',
            narrative: $store.state.ui.mode === 'narrative',
            flipped,
            onesided:
              $store.state.isMobile &&
              $store.state.isLandscape &&
              $route.name === 'narrative'
          }"
        >
          <div class="flex" v-if="$store.state.ui.mode !== 'no-map'">
            <div
              v-for="(year, i) in years"
              :key="year + 'shadow'"
              class="subcanvas"
            >
              <YearPicker
                :year="year"
                @setYear="y => setYear(i, y)"
                @removeYear="removeYear(i)"
                :first="years.length < 2"
                :index="i"
                :years="$store.state.years.filter(y => years.indexOf(y) < 0)"
              />
            </div>
            <div
              :class="{
                addYear: true,
                'year-highlight': $store.state.ui.mode === 'year-highlight',
                disabled: $route.name === 'narrative',
                nbutton: true
              }"
              @click="$route.name === 'narrative' ? null : addYear()"
              v-if="!$store.state.isMobile"
            >
              Add year
              <div class="plus">+</div>
            </div>
          </div>

          <FlipButton />
        </div>

        <div
          :class="{
            map: true,
            'no-map': $store.state.ui.mode === 'no-map',
            'no-years': $store.state.ui.mode === 'no-years'
          }"
        >
          <div
            :class="{
              'ChooseRide-container': true
            }"
          >
            <ChooseRide />
          </div>
          <div class="InsetMap-container">
            <InsetMap />
          </div>
        </div>

        <div
          :class="{
            bottom: true,
            canvas: true,
            shrunk: years.length > 1,
            expanded: false,
            'no-map': $store.state.ui.mode === 'no-map',
            'no-years': $store.state.ui.mode === 'no-years',
            'year-highlight': $store.state.ui.mode === 'year-highlight',
            'highlight-flip': $store.state.ui.mode === 'highlight-flip',
            'highlight-location': $store.state.ui.mode === 'highlight-location',
            narrative: $store.state.ui.mode === 'narrative',
            flipped,
            onesided:
              $store.state.isMobile &&
              $store.state.isLandscape &&
              $route.name === 'narrative'
          }"
        >
          <div class="flex"></div>
        </div>
      </div>
      <ShareModal
        v-if="$store.state.ui.share && $route.name !== 'MapModal'"
        terminology="Scene"
      />
    </div>
    <router-view />
    <Footer v-if="!$store.state.isMobile" />
  </fragment>
</template>

<script>
import { MglMap } from "vue-mapbox";
import BookViewToggle from "../components/BookViewToggle";
import ChooseRide from "../components/ChooseRide";
import ImageFlipper from "../components/ImageFlipper";
import InsetMap from "../components/InsetMap";
import Intersections from "../components/Intersections";
import DrivingControls from "../components/DrivingControls";
import HelpButton from "../components/HelpButton";
import Ride from "../components/Ride";
import YearControls from "../components/YearControls";
import YearPicker from "../components/YearPicker";
import SearchBox from "../components/SearchBox";
import FlipButton from "../components/FlipButton";
import ScrollControls from "../components/ScrollControls";
import ShareModal from "../components/ShareModal";
import Footer from "../components/Footer";
import TouchControls from "../components/TouchControls";
import MiniMobileHeaderBar from "../components/MiniMobileHeaderBar";
import InsetButton from "../assets/inset.svg?inline";
import NextButton from "../assets/next.svg?inline";
import { mapboxGlAccessToken, mapboxGlStyle } from "../constants/constants";
import { DEFAULT_YEAR } from "../constants/constants";

export default {
  name: "MapView",
  components: {
    BookViewToggle,
    ChooseRide,
    HelpButton,
    InsetMap,
    InsetButton,
    Intersections,
    MglMap,
    NextButton,
    ImageFlipper,
    DrivingControls,
    Ride,
    YearControls,
    YearPicker,
    SearchBox,
    FlipButton,
    ScrollControls,
    ShareModal,
    Footer,
    TouchControls,
    MiniMobileHeaderBar
  },
  props: {
    flipOverride: null
  },
  data() {
    return {
      mapboxGlAccessToken,
      mapboxGlStyle,
      minimap: 0
    };
  },
  computed: {
    bearing() {
      return this.$store.getters.currentLatLonZoom.bearing;
    },
    zoom() {
      let alpha = this.minimap;

      return (
        alpha * 11 + (1 - alpha) * this.$store.getters.currentLatLonZoom.zoom
      );
    },
    years() {
      if (this.$store.state.yearOverride)
        return [this.$store.state.yearOverride];
      if (!this.$route.params.year) return ["" + DEFAULT_YEAR];
      let years = this.$route.params.year.split(",");
      return years;
    },
    flipped() {
      if (typeof this.flipOverride == "undefined") {
        return this.$store.state.geolocation.flipped;
      } else {
        return this.flipOverride;
      }
    },
    mapViewTransitioning() {
      return this.$store.state.ui.mapViewTransitioning;
    },
    uiMode() {
      return this.$store.state.ui.mode;
    }
  },
  methods: {
    handleTransitionStart() {
      this.$store.commit("setMapViewTransitioning", true);
    },
    handleTransitionEnd() {
      this.$store.commit("setMapViewTransitioning", false);
    },
    mapLoaded(map) {
      this.map = map;
    },
    navigate(direction) {
      this.$store.commit("accelerate", direction * 100);
      setTimeout(() => this.$store.commit("accelerate", 0), 1000);
    },

    navigateToYears(years) {
      let newYears = [...years];
      newYears = newYears.sort();
      this.$router.push({
        params: { year: newYears.join(",") },
        query: this.$route.query
      });
    },

    setYear(index, year) {
      let newYears = [...this.years];
      newYears[index] = year;
      this.navigateToYears(newYears);
    },

    addYear() {
      let newYears = this.years.slice();
      let lastIndex = this.$store.state.years.indexOf(
        newYears[newYears.length - 1]
      );

      if (newYears.length === this.$store.state.years.length) return;

      if (lastIndex < this.$store.state.years.length - 1) {
        lastIndex++;
      } else {
        lastIndex = 0;
        while (newYears.indexOf(this.$store.state.years[lastIndex]) >= 0)
          lastIndex++;
      }
      newYears.push(this.$store.state.years[lastIndex]);
      this.navigateToYears(newYears);
    },

    removeYear(i) {
      let newYears = [
        ...this.years.slice(0, i),
        ...this.years.slice(i + 1, this.years.length)
      ];
      this.navigateToYears(newYears);
    }
  },
  watch: {
    mapViewTransitioning(transitioning) {
      if (!transitioning && this.map) {
        this.map.map.resize();
      }
    },

    uiMode(_, from) {
      if (from === "no-map") {
        const isSafari = /^((?!chrome|android).)*safari/i.test(
          navigator.userAgent
        );

        if (!isSafari && this.map) {
          let interval = window.setInterval(() => this.map.map.resize(), 30);
          window.setTimeout(() => window.clearInterval(interval), 1000);
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/constants/_variables.scss";

.map-container {
  height: calc(100% - 26px);
  width: 100%;
  position: relative;

  @media (max-width: 815px) {
    height: 100%;
  }
}

.map-view {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: 1s transform;
  position: absolute;
  top: 0px;
  left: 0px;

  &.flipped {
    transform: rotate(180deg);
  }

  &.interface-shadow {
    pointer-events: none;

    .canvas {
      position: relative;
    }

    .year {
      pointer-events: all;
    }

    .addYear {
      pointer-events: all;

      &.year-highlight {
        background-color: $light-gold;
        color: $copper;
      }

      &.disabled {
        cursor: default;

        &:hover {
          font-weight: normal;
        }
      }
    }

    .no-years {
      opacity: 0;
    }
  }

  &.book-view {
    .ChooseRide-container {
      display: none;
    }

    .inset-button {
      display: none;
    }

    .InsetMap-container {
      display: none;
    }

    .ride-wrapper {
      display: none;
    }

    .addYear {
      display: none;
    }

    .FlipButton {
      background: black;
      color: white;

      &:hover {
        background-color: $light-gold;
        color: $copper;
      }
    }
  }
}

.map {
  width: 100%;
  height: 20%;
  position: relative;
  transition: 1s height;

  &.no-map {
    height: 0%;
    opacity: 0;

    .truck {
      opacity: 0;
    }
  }
}

.map-view.flipped {
  .mgl-map-wrapper {
    transform: rotate(-180deg);
  }
}

.canvas {
  width: 100vw;
  height: 40%;
  transition: 1s height, 1s padding;

  &.no-map {
    height: 50%;

    .subcanvas {
      padding-bottom: 0px !important;
    }

    &.bottom .subcanvas {
      padding-top: 0px !important;
    }
  }

  &.no-years,
  &.year-highlight,
  &.highlight-location,
  &.highlight-flip,
  &.narrative {
    height: 50%;

    &.flipped {
      height: 30%;
    }
  }

  &.bottom.no-years,
  &.bottom.year-highlight,
  &.bottom.highlight-flip,
  &.bottom.highlight-location,
  &.bottom.narrative {
    height: 30%;

    &.flipped {
      height: 50%;
    }
  }

  .flex {
    display: flex;
    flex-direction: column;
    position: relative;
    transition: 1s height;
    height: 100%;
    width: 100%;
  }

  &.expanded {
    height: 60%;
  }

  &.shrunk {
    height: 20%;
  }

  .subcanvas {
    flex-shrink: 1;
    flex-grow: 0;
    height: 100%;
    position: relative;
    padding-bottom: 10px;
    transition: 1s height, 1s padding;

    &:last-child {
      padding-bottom: 5px;
    }
  }

  &.bottom .subcanvas {
    padding-top: 10px;
    padding-bottom: 0px;

    &:first-child {
      padding-top: 5px;
    }
  }

  &.shrunk.bottom .subcanvas {
    padding-top: 5px;
    padding-bottom: 0px;
  }

  .grow-enter-active,
  .grow-leave-active {
    transition: height 1s, padding 1s;
  }

  .grow-enter,
  .grow-leave-to {
    height: 0% !important;
    padding-bottom: 0px !important;
    padding-top: 0px !important;
  }

  .addYear {
    position: absolute;
    bottom: 15px;
    left: 10px;
    font-size: 15px;

    .plus {
      display: inline-block;
      margin-left: 0.5em;
    }
  }

  &.onesided.top {
    height: 80%;

    &.no-map {
      height: 100%;
    }
  }

  &.onesided.bottom {
    height: 0%;
  }
}

.ride-wrapper {
  position: absolute;
  width: 150px;
  z-index: 50;
  top: calc(50% - 57px + 15px);
  left: calc(50% - 75px);
  pointer-events: none; /* May need to be 'all' if alt rides enabled again */
  transition: 1s transform;

  @media (max-width: 815px) {
    width: 100px;
    left: calc(50% - 50px);
    top: calc(50% - 57px + 15px + 18px);
  }
}

.inset-button {
  cursor: pointer;
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  top: $edge-spacing;
  left: $edge-spacing;

  svg:hover {
    path {
      fill: $light-gold;
    }
  }

  @media (max-width: 815px) {
    display: none;
  }

  &.flipped {
    top: unset;
    left: unset;
    right: $edge-spacing;
    bottom: $edge-spacing;

    svg {
      transform: rotate(180deg);
    }
  }
}

.BookViewToggle-container {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 99;
}

.InsetMap-container {
  height: 100%;
  position: absolute;
  left: 0;
  z-index: 2;
}

.ChooseRide-container {
  height: 100%;
  position: absolute;
  right: 0;
  z-index: 100;
}

.search {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 50;
  display: flex;
  align-items: flex-start;
  z-index: 102;
}

.help {
  position: absolute;
  right: 10px;
  top: 50px;
  z-index: 99;
}

.minimobile {
  margin-left: 1em;
  margin-top: -10px;
  margin-right: -10px;
}

.navigate {
  &-left,
  &-right {
    cursor: pointer;
    height: 40px;
    position: absolute;
    top: calc(50% - 20px);

    svg path {
      fill: black;
    }

    &:hover {
      svg path {
        fill: $dark-red;
      }
    }
  }

  &-left {
    left: 10px;
    transform: rotate(180deg);
  }

  &-right {
    right: 10px;
  }
}
</style>

<style lang="scss">
.map {
  .mapboxgl-map {
    .mapboxgl-ctrl-bottom-right {
      right: 50px;
    }
  }
}

.map-view.flipped {
  /* TODO rotate breaks z-index, so some elements appear above tour shadow */
  .map .mapboxgl-map .mapboxgl-control-container {
    display: none;
  }
}

.v-tour--active {
  /* 
   * Make ride wrapper above all other UI during tour.
   * ensures everything else gets blacked out.
   */
  .ride-wrapper {
    z-index: 102;
  }
}
</style>
